import Listado from "./Listado";
import Afiliada from "./afiliada";
import Citologia from "./citologia";
import Privada from "./privada";
import Inmunohistoquimica from "./inmunohistoquimica";

const paginas = { Listado, Afiliada, Citologia, Privada, Inmunohistoquimica };
export default paginas;
